export const COMPANY_NAME = 'I2M LLC ("STREAMETRIC")';

export const BILLING_AUTHORIZATION = {
  TEXT: `I authorize ${COMPANY_NAME} to bill for subscription renewals to the provided billing address according to the`,
  SAAS_AGREEMENT_LINK_TEXT: 'SaaS Agreement',
  SAAS_AGREEMENT_HREF: 'https://streametric.io/saas-agreement/',
  PRIVACY_POLICY_LINK_TEXT: 'Privacy Policy',
  PRIVACY_POLICY_HREF: 'https://streametric.io/privacy-policy',
};

export const BILLING_INFORMATION_TOOLTIPS = {
  USE_DIFFERENT_BILLING_ADDRESS:
    'Enable this if the billing address is different from the company address.',
  AUTO_RENEWAL: `If checked, the billing admin authorizes ${COMPANY_NAME} to automatically send invoices for the renewal amount for the renewal date.`,
  SAVE_NO_CHANGES: 'No changes to save.',
  SAVE_VALIDATION_ERRORS: 'All mandatory fields must be filled in before saving.',
  SAVE_AUTHORIZE_BILLING: 'You must authorize billing before saving.',
};
